import { Directive, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { ModalConfirmConfig } from './default-content.config';
import { ConfirmContentComponent } from './default-content/confirm-content.component';

@Directive({
    selector: '[appConfirm]'
})
export class ModalConfirmDirective {
    constructor(private modalService: NgbModal, private config: ModalConfirmConfig) {

    }

    @Input() title = 'Are you sure?';
    @Input() message: string;
    @Input() options: any;
    @Output() confirm = new EventEmitter<any>();
    @Output() cancel = new EventEmitter<any>();
    private href;

    @HostListener('click', ['$event']) onClick($event) {
        this.openModal();
        if ($event.target.tagName === 'A' && $event.target.href) {
            this.href = $event.target.href;
            return false; // prevent navigation from happening at this point
        }
    }

    openModal() {
        const defaults = {
            confirmBtnText: this.config.confirmBtnText,
            confirmBtnClass: this.config.confirmBtnClass,
            cancelBtnText: this.config.cancelBtnText,
            cancelBtnClass: this.config.cancelBtnClass,
            modalSize: this.config.modalSize,
            modalClass: this.config.modalClass
        };

        if (this.options) {
            for (const key of Object.keys(defaults)) {
                defaults[key] = this.options[key] || defaults[key];
            }
        }

        const modalRef = this.modalService.open(ConfirmContentComponent, {
            backdrop: 'static',
            size: defaults.modalSize,
            windowClass: defaults.modalClass
        });

        modalRef.componentInstance.message = this.message;
        modalRef.componentInstance.title = this.title;
        modalRef.componentInstance.options = defaults;

        modalRef.result.then(() => {
            if (this.href) {
                window.location.href = this.href;
            }
            this.confirm.next();
        }).catch(reason => {
            if (this.cancel) {
                this.cancel.next();
            }
        });
    }
}
